<nb-card class="card-box">
    <nb-card-header class="content-header">
        <span class="title">{{'common.privacy-policy-and-terms-of-use' | translate}}</span>
    </nb-card-header>
    <div [nbSpinner]="loading" nbSpinnerSize="large">
        <nb-card-body class="content-body">
            <div class="content-body__terms" [innerHTML]="termsOfUseContent | safe:'html'"></div>
        </nb-card-body>
        <nb-card-footer class="content-footer">
            <button nbButton [status]="'primary'" [size]="'large'" tabindex="-1"
                (click)="close()">{{'common.I-got-acquainted' | translate}}</button>
        </nb-card-footer>
    </div>
</nb-card>